import styled, { keyframes } from "styled-components";

export const SaquesContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  padding: 40px;
  box-sizing: border-box;
  background-image: url("/textura.jpg");
  background-size: cover;
  background-attachment: fixed;
`;

export const ContentBox = styled.div`
  background: rgba(30, 30, 30, 0.9);
  backdrop-filter: blur(10px);
  border-radius: 8px;
  padding: 30px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.37);
`;

export const SaquesFirstContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`;

export const AreaTitle = styled.h2`
  margin: 0;
  color: #e6aa3a;
  font-size: 28px;
`;

export const Filtros = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 30px;

  @media (min-width: 1100px) {
    flex-direction: row;
    align-items: flex-end;
  }
`;

export const SearchBar = styled.div`
  display: flex;
  flex: 1;

  input {
    flex-grow: 1;
    height: 45px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    background: rgba(0, 0, 0, 0.3);
    padding: 0 20px;
    color: #fff;
    border-radius: 6px 0 0 6px;
    &:focus {
      outline: none;
      border-color: #e6aa3a;
    }
  }

  button {
    width: 60px;
    height: 45px;
    border: none;
    background: #e6aa3a;
    color: #111;
    cursor: pointer;
    border-radius: 0 6px 6px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
  }
`;

export const FiltroStatus = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 15px;
  flex: 3;

  .box {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .title {
    font-size: 11px;
    color: #e6aa3a;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 1px;
  }

  .selectBox {
    height: 45px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    background: rgba(0, 0, 0, 0.4);
    padding: 0 12px;
    color: #fff;
    border-radius: 6px;
    font-size: 13px;
    cursor: pointer;
    width: 100%;
    box-sizing: border-box;

    &:focus {
      outline: none;
      border-color: #e6aa3a;
    }

    &::-webkit-calendar-picker-indicator {
      filter: invert(1);
      cursor: pointer;
    }

    &::placeholder {
      color: rgba(255, 255, 255, 0.4);
    }
  }

  input[type="number"] {
    -moz-appearance: textfield;
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
`;

export const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;

  &::-webkit-scrollbar {
    height: 8px;
  }
  &::-webkit-scrollbar-thumb {
    background: #e6aa3a;
    border-radius: 10px;
  }
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  min-width: 1100px;
`;

export const TableHeader = styled.thead``;
export const TableRow = styled.tr`
  color: rgba(255, 255, 255, 0.9);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);

  &:first-child {
    background-color: rgba(0, 0, 0, 0.3);
    border-bottom: 2px solid #e6aa3a;
  }

  &:hover:not(:first-child) {
    background: rgba(255, 255, 255, 0.03);
  }
`;

export const TableHeaderCell = styled.th`
  padding: 18px 15px;
  text-align: left;
  white-space: nowrap;
  color: #fff;
  font-weight: 600;
  font-size: 14px;
`;

export const TableBody = styled.tbody``;
export const TableCell = styled.td`
  padding: 18px 15px;
  text-align: left;
  white-space: nowrap;
  font-size: 14px;
`;

export const GoldenStatus = styled.span`
  color: ${props => props.isGolden ? '#E6AA3A' : 'rgba(255,255,255,0.7)'};
  font-weight: ${props => props.isGolden ? '800' : '400'};
  text-transform: ${props => props.isGolden ? 'uppercase' : 'none'};
  ${props => props.isGolden && `
    text-shadow: 0 0 8px rgba(230, 170, 58, 0.4);
    letter-spacing: 1px;
  `}
`;

export const ActionButton = styled.button`
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 6px;
  padding: 8px 14px;
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;

  &.cancel {
    background: #c0392b;
    border-color: transparent;
    &:hover {
      background: #e74c3c;
      transform: scale(1.05);
    }
  }

  &:hover:not(.cancel) {
    background: #e6aa3a;
    color: #111;
    border-color: #e6aa3a;
    transform: translateY(-2px);
  }
`;

const fadeIn = keyframes`from { opacity: 0; } to { opacity: 1; }`;
const slideIn = keyframes`from { transform: scale(0.95); opacity: 0; } to { transform: scale(1); opacity: 1; }`;

export const ModalConta = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.85);
  backdrop-filter: blur(8px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  animation: ${fadeIn} 0.3s ease;
  padding: 20px;
  box-sizing: border-box;

  .box {
    background: #1a1a1a;
    border-radius: 12px;
    width: 100%;
    max-width: 500px;
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.8);
    animation: ${slideIn} 0.4s ease-out;
    border: 1px solid #e6aa3a;
    position: relative;
    padding: 40px;
  }

  .title {
    margin: 0 0 25px 0;
    color: #e6aa3a;
    font-size: 24px;
    text-align: center;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    padding-bottom: 20px;
  }

  .close {
    position: absolute;
    top: 20px;
    right: 20px;
    background: transparent;
    border: none;
    color: #fff;
    font-size: 26px;
    cursor: pointer;
    opacity: 0.5;
    transition: 0.2s;
    &:hover {
      opacity: 1;
      color: #e6aa3a;
    }
  }

  .account {
    color: #fff;
    display: flex;
    flex-direction: column;
    gap: 15px;

    .boxzinha {
      background: rgba(255, 255, 255, 0.03);
      padding: 12px;
      border-radius: 6px;
      font-size: 15px;
      border-left: 3px solid #e6aa3a;

      strong {
        color: #e6aa3a;
        margin-right: 10px;
        font-size: 12px;
        text-transform: uppercase;
      }
    }
  }

  .ask {
    margin-top: 25px;
    padding-top: 20px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    display: flex;
    justify-content: center;
  }
`;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 40px;
  gap: 20px;
  color: #fff;
  font-size: 14px;
`;

export const PaginationButton = styled.button`
  background: rgba(255, 255, 255, 0.05);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  padding: 10px 20px;
  font-weight: 600;
  transition: all 0.3s;
  cursor: pointer;

  &:hover:not(:disabled) {
    background: #e6aa3a;
    color: #111;
    border-color: #e6aa3a;
  }
  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
`;
